export default {
  "hidden": "_hidden_3t16d_1",
  "input": "_input_3t16d_4",
  "infoText": "_infoText_3t16d_13",
  "wrapper": "_wrapper_3t16d_18",
  "dragging": "_dragging_3t16d_25"
};import "ni:sha-256;t19Aq7ZgrdY3wRdNEvZGdglPiGD4ulm4Vf2q7dKmU58";